import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { RegistroService } from 'src/app/core/services/registros/registro.service';
import { TokenService } from 'src/app/core/services/token/token.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tabela-registro',
  templateUrl: './tabela-registro.component.html',
  styleUrls: ['./tabela-registro.component.scss']
})
export class TabelaRegistroComponent implements OnInit {
  displayedColumns: string[] = ['linha','matricula', 'nomeSegurado', 'cpf', 'email', 'dataAdesao',
    'dataInicioDoContratoDeFinanciamento', 'dataTerminoDoContratoDeFinanciamento',
    'prazoFinanciamento', 'capitalSegurado', 'valorDaParcelaMensalDoFinanciamento', 'premioUnicoDoSeguro', 'status', 'baixar'];
  dataSource = new MatTableDataSource<any>();
  totalRecords = 0;
  registrosOriginais: any[] = [];

  currentPage: number = 0;
  pageSize: number = 10;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataInicioCorte: string = '';
  dataFimCorte: string = '';

  public showLoader = false;

  constructor(
    private registroService: RegistroService,
    private router: Router,
    private tokenService: TokenService
  ) { }

  ngOnInit(): void {
    if (!this.tokenService.isAuthenticated()) {
      this.router.navigate(['/auth']);
      return;
    }
    this.loadRegistros();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  loadRegistros(): void {
    this.showLoader = true
    this.registroService.getRegistros(this.currentPage, this.pageSize).subscribe(
      data => {
        if (data && data.content) {
          this.dataSource.data = [];
          this.dataSource = new MatTableDataSource(data.content);
        }

        this.totalRecords = data.totalElements || 0;
        if (this.paginator) {
          this.paginator.length = this.totalRecords;
          this.paginator.pageIndex = this.currentPage;
          this.paginator.pageSize = this.pageSize;
        }
        this.showLoader = false
      },
      error => {
        this.showLoader = false
        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar registros',
          text: error.error.message
        })
        console.error('Erro ao buscar registros', error)}
    );
  }

  onPageChange(event: any): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadRegistros();
  }

  filtrarRegistrosPendentes(pendente:Boolean): void {
    if (!this.dataInicioCorte || !this.dataFimCorte) {
      alert('Preencha as datas de início e fim!');
      return;
    }

    const dataInicioFormatada = this.formatarData(this.dataInicioCorte);
    const dataFimFormatada = this.formatarData(this.dataFimCorte);

    this.showLoader = true

    this.registroService.getRegistrosPendentes(dataInicioFormatada, dataFimFormatada, pendente).subscribe(
      data => {
        this.dataSource.data = data.content;
        this.totalRecords = data.totalElements;
        if (this.paginator) {
          this.paginator.length = this.totalRecords;
          this.paginator.pageIndex = 0;
          this.paginator.pageSize = this.pageSize;
        }
        this.showLoader = false
      },
      error => {
        this.showLoader = false
        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar registros',
          text: error.error.message
        })}
    );
}


  visualizarRegistros(atualizarStatusComoEnviado: boolean): void {
    if (!this.dataInicioCorte || !this.dataFimCorte) {
      alert('Preencha as datas de início e fim!');
      return;
    }

    const dataInicioFormatada = this.formatarData(this.dataInicioCorte);
    const dataFimFormatada = this.formatarData(this.dataFimCorte);

    this.showLoader = true

    this.registroService.downloadRegistros(dataInicioFormatada, dataFimFormatada, atualizarStatusComoEnviado).subscribe(
      response => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'registros.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        this.showLoader = false;
      },
      error => {
        this.showLoader = false
        Swal.fire({
          icon: 'error',
          text: error.message
        })
      }
    );
  }

  baixarProposta(matricula: string): void {
    if (!matricula) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Matrícula não encontrada para este registro.'
      });
      return;
    }

    this.showLoader = true;

    this.registroService.downloadMatricula(matricula).subscribe(
      response => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `proposta_${matricula}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
        Swal.fire({
          icon: 'error',
          title: 'Erro ao baixar a proposta',
          text: error.error?.message || 'Ocorreu um erro inesperado.'
        });
      }
    );
  }


  formatarData(data: any): string {
    const dataObj = new Date(data);
    const ano = dataObj.getFullYear();
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
    const dia = dataObj.getDate().toString().padStart(2, '0');
    return `${ano}/${mes}/${dia}`;
  }

  maskDate(val: any){
    return  new Date(val).toLocaleString('pt-br', {timeZone: 'UTC'}).slice(0, 10);
  }

  maskValores(val: string) {
    if (!val) return '';
    return Number(val).toLocaleString('BRL', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

}
